// For condition constraints see https://naspersclassifieds.atlassian.net/browse/GS-4324
export default function shouldHideRatings(reviewCount: number, averageValue: number): boolean {
  return reviewCount < 5 || averageValue < 3.8;
}
